import type { FormFieldInformationProps } from '.';
import { Icon } from '../..';

export function FormFieldInformation({ children, ...props }: FormFieldInformationProps) {
  return (
    <div className="mt-1 flex items-center gap-[6px] bg-neutral-100 p-1" data-testid="input-information" {...props}>
      <Icon
        className="shrink-0 text-neutral-600"
        filled={false}
        height={16}
        icon="InformationIcon"
        role="img"
        width={16}
      />
      <span className="body-300-light text-neutral-800">{children}</span>
    </div>
  );
}
